import axiosInstance from './axiosInstance';

export function singleMissionChecks(missionId, payload) {
  return axiosInstance.post(`/missions/${missionId}/checks`, payload);
}

export default {
  singleMissionChecks,
};
